__turbopack_context__.v({
  "container": "KwhSxW_container",
  "hasSquareBorders": "KwhSxW_hasSquareBorders",
  "shortContainer": "KwhSxW_shortContainer",
  "video-js": "KwhSxW_video-js",
  "videoPlayer": "KwhSxW_videoPlayer",
  "vjs-control-bar": "KwhSxW_vjs-control-bar",
  "vjs-loading-spinner": "KwhSxW_vjs-loading-spinner",
});
